import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { ModalLoading } from "../../../../../../common/components/modal_loading";
import FormContainer from "../../../../../../common/components/form_container";
import DefaultFormInput from "../../../../../../common/components/default_form_input";
import { useCallback, useEffect } from "react";
import { FormDatePickerInput } from "../../../../../../common/components/masked_inputs/react_forms/form_date_picker_input";
import PrimaryButton from "../../../../../../common/components/primary_button";
import { AuditoriaCopiaForm, AuditoriaCopiaSchema, defaultAuditoriaCopiaForm } from "../../../schemas/Auditoria_auditoria/auditoria_copia";
import { AuditoriasLista } from "../../../../domain/models/auditorias_lista";
import dayjs from "dayjs";

type props = {
    open: boolean,
    saving: boolean,
    selectedAuditoriaCopia: AuditoriasLista | undefined,
    titulo: string,
    onClose: () => void,
    onSubmit: (form: AuditoriaCopiaForm) => void,

}

export const CopiaAuditoriaModal = ({
    open,
    saving,
    selectedAuditoriaCopia,
    titulo,
    onClose,
    onSubmit,

}: props) => {

    const hookForm = useForm<AuditoriaCopiaForm>({
        mode: "onSubmit",
        reValidateMode: "onSubmit",
        defaultValues: defaultAuditoriaCopiaForm,
        resolver: zodResolver(AuditoriaCopiaSchema),
    });

    useEffect(() => {
        if (selectedAuditoriaCopia) {
            hookForm.setValue('idAuditoria', selectedAuditoriaCopia.IdAuditoria);
            hookForm.setValue('evento', selectedAuditoriaCopia.Evento);
            hookForm.setValue('dataAuditoria', dayjs.utc(selectedAuditoriaCopia.DataAuditoria).toDate());
        }

    }, [selectedAuditoriaCopia, titulo, hookForm]);

    const handleSubmit = useCallback((form: AuditoriaCopiaForm) => {
        if (!saving) {
            onSubmit(form);
            hookForm.reset();
        }

    }, [saving, onSubmit, hookForm]);

    const handleClose = useCallback(() => {
        if (!saving) onClose();
    }, [saving, onClose]);

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            slotProps={{
                paper: {
                    component: 'form',
                    sx: { width: 400 },
                    onSubmit: hookForm.handleSubmit(handleSubmit)
                }

            }}
            sx={{
                "& .MuiDialog-container": {
                    "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "45rem",
                    },
                },
            }}>

            <DialogTitle>
                Copiar Auditoria
            </DialogTitle>

            <DialogContent>
                <ModalLoading loading={saving}  >
                    <FormContainer title={"Informações"} arrangement="fullRow">
                        <>
                            <DefaultFormInput
                                name='evento'
                                label='Evento'
                                reactHookForm={hookForm}

                            />
                            <FormDatePickerInput
                                name='dataAuditoria'
                                label='Data da auditoria'
                                required={false}
                                reactHookForm={hookForm}
                            />
                        </>
                    </FormContainer>

                </ModalLoading>
            </DialogContent>

            <DialogActions>
                <div className="w-full h-full items-center justify-end flex px-4 pb-4 gap-4">

                    <div className="flex flex-row gap-2">
                        <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
                            <h1
                                className="text-sm text-black dark:text-white"
                                onClick={handleClose}>
                                Cancelar
                            </h1>
                        </div>

                        <div className="w-[120px]">
                            {saving ? (
                                <PrimaryButton
                                    buttonColor="primary-green">
                                    Salvando...
                                </PrimaryButton>
                            ) : (
                                <PrimaryButton
                                    type="submit"
                                    buttonColor="primary-green">
                                    Salvar
                                </PrimaryButton>
                            )}
                        </div>
                    </div>
                </div>
            </DialogActions>

        </Dialog>
    );
}